import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faExternalLink,
  faChartLine as fasChartLine,
  faCheck as fasCheck,
  faChevronDown as fasChevronDown,
  faChevronRight as fasChevronRight,
  faChevronUp as fasChevronUp,
  faEllipsisH as fasEllipsisH,
  faExclamationCircle as fasExclamationCircle,
  faGift as fasGift,
  faTimes as fasTimes,
  faUserCog as fasUserCog
} from '@fortawesome/free-solid-svg-icons'
import {
  faAngleUp,
  faBell,
  faCalculatorAlt,
  faCalendarAlt,
  faCalendarExclamation,
  faChartPieAlt,
  faCheckCircle,
  faChevronDown,
  faChevronRight,
  faClock,
  faCreditCard,
  faCreditCardBlank,
  faDonate,
  faEllipsisH,
  faFileInvoice,
  faFileInvoiceDollar,
  faGlobe,
  faHandHoldingUsd,
  faHandsUsd,
  faListAlt,
  faMedal,
  faMoneyCheckAlt,
  faPercentage,
  faPhone,
  faPhoneLaptop,
  faReceipt,
  faStarChristmas,
  faTrashAlt,
  faUserCog,
  faWallet,
  faAngleDown as falAngleDown,
  faAngleLeft as falAngleLeft,
  faAngleRight as falAngleRight,
  faCloudRain as falCloudRain,
  faExclamationTriangle as falExclamationTriangle,
  faGift as falGift
} from '@fortawesome/pro-light-svg-icons'
import {
  faAngleDown,
  faAngleLeft,
  faBars,
  faCalendarDay,
  faCalendarDays,
  faChartLine,
  faCheck,
  faCirclePlus,
  faDollarSign,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faFileAlt,
  faGear,
  faInfoCircle,
  faLink,
  faMagnifyingGlass,
  faMessagePen,
  faPen,
  faPersonToDoor,
  faSignOutAlt,
  faSpinner,
  faSquareSlidersVertical,
  faStoreAltSlash,
  faStoreSlash,
  faSync,
  faSyncAlt,
  faTimes,
  faTriangleExclamation,
  faUndoAlt,
  faUniversity,
  faUsdCircle,
  faUser,
  faXmark,
  faAngleUp as farAngleUp,
  faBadgePercent as farBadgePercent,
  faBagShopping as farBagShopping,
  faFileInvoice as farFileInvoice,
  faFolderOpen as farFolderOpen,
  faGift as farGift,
  faGlobe as farGlobe,
  faListAlt as farListAlt,
  faLock as farLock,
  faMoneyCheckAlt as farMoneyCheckAlt
} from '@fortawesome/pro-regular-svg-icons'
import {
  faBadgePercent,
  faUserCircle,
  faCalendarAlt as fasCalendarAlt,
  faChartPieAlt as fasChartPieAlt,
  faCreditCard as fasCreditCard,
  faFileInvoice as fasFileInvoice,
  faGear as fasGear,
  faListAlt as fasListAlt,
  faTriangleExclamation as fasTriangleExclamation
} from '@fortawesome/pro-solid-svg-icons'

library.add(
  faAngleDown,
  faAngleLeft,
  faAngleUp,
  faAngleUp,
  faBadgePercent,
  faBars,
  faBell,
  faCalculatorAlt,
  faCalendarAlt,
  faCalendarDay,
  faCalendarExclamation,
  fasCalendarAlt,
  faCalendarDays,
  faChartPieAlt,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronRight,
  faCirclePlus,
  faClock,
  faCreditCard,
  faCreditCardBlank,
  faDollarSign,
  faDonate,
  faEllipsisH,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faFileAlt,
  faFileInvoice,
  faFileInvoiceDollar,
  faGear,
  faGlobe,
  faHandHoldingUsd,
  faHandsUsd,
  faInfoCircle,
  falAngleDown,
  falAngleLeft,
  falAngleRight,
  falCloudRain,
  falExclamationTriangle,
  faExternalLink,
  farFolderOpen,
  falGift,
  faLink,
  faListAlt,
  faMedal,
  faMessagePen,
  faMoneyCheckAlt,
  faPen,
  faPercentage,
  faPersonToDoor,
  faPhone,
  faPhoneLaptop,
  farAngleUp,
  farBadgePercent,
  farBagShopping,
  faReceipt,
  farFileInvoice,
  farGift,
  farMoneyCheckAlt,
  farListAlt,
  fasChartLine,
  fasChartPieAlt,
  fasCheck,
  fasChevronDown,
  fasChevronRight,
  fasChevronUp,
  fasCreditCard,
  fasEllipsisH,
  fasExclamationCircle,
  fasFileInvoice,
  fasGear,
  fasGift,
  faSignOutAlt,
  fasListAlt,
  faSpinner,
  faSquareSlidersVertical,
  faStarChristmas,
  fasTimes,
  faStoreAltSlash,
  faStoreSlash,
  fasUserCog,
  faSync,
  faSyncAlt,
  faTimes,
  faTrashAlt,
  faTriangleExclamation,
  fasTriangleExclamation,
  faUndoAlt,
  faUniversity,
  faUsdCircle,
  faUser,
  faUserCircle,
  faUserCog,
  faWallet,
  faXmark,
  faChartLine,
  farGlobe,
  faMagnifyingGlass,
  farLock
)
